import { createContext } from 'react';

type OnlineStatusContext = {
  isOnline: boolean;
  requestQueueLength: number;
  requestQueueLengthStart: number;
  shouldShowNotificationOnPage: boolean;
  manualHandleLineStatus: () => Promise<boolean>;
};

export const OnlineStatusContext = createContext<OnlineStatusContext>({
  isOnline: true,
  requestQueueLength: 0,
  requestQueueLengthStart: 0,
  shouldShowNotificationOnPage: false,
  manualHandleLineStatus: () => new Promise<boolean>((resolve) => resolve(true)),
});
